import React from 'react';
import { t } from '../../../../../types/translation/Translator';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import { BaseFilter, BaseFilterProps } from '../../common/BaseFilter';
import { CustomFieldEntityType } from '../../../../../types/custom_field/customField';
import { CustomFieldEntityTypeFilterDropdownContent, CustomFieldEntityTypeFilterInnerContent } from './DropdownContent';
import { itemsContainText } from '../../../../../util/string.util';
import { CustomFieldUtil } from '../../../../../types/custom_field';

export class CustomFieldEntityTypeFilter extends BaseFilter<CustomFieldEntityType> {
  toLabel(): string {
    return t(TranslationKey.entityType).singular.label;
  }

  toIcon(): React.JSX.Element {
    return <></>;
  }

  toDropdownContent(props: BaseFilterProps): React.JSX.Element {
    return (
      <CustomFieldEntityTypeFilterDropdownContent
        filter={this}
        filterProps={props.filterProps}
        setFilterProps={props.setFilterProps}
      />
    );
  }

  toInnerContent(props: BaseFilterProps): string | JSX.Element {
    return (
      <CustomFieldEntityTypeFilterInnerContent
        filter={this}
        filterProps={props.filterProps}
        setFilterProps={props.setFilterProps}
      />
    );
  }

  search(item: CustomFieldEntityType, query: string): boolean {
    return itemsContainText(query, [item, CustomFieldUtil.customFieldEntityTypeToString(item)]);
  }

  toCount(): number {
    return 0;
  }
}
